<template>
  <BasePageContainer class="admin pt-4">
    <page-header
      has-back>
      テンプレート管理
    </page-header>
    <div class="page__body admin-content pt-5">
      <div class="body-header">
        <category-checkbox-list />
      </div>
      <ul
        class="list-unstyled mt-3">
        <template-list-item
          v-for="template in _templates"
          :key="template.id"
          :template="template">
          <div class="template__actions d-inline-block">
            <button
              class="template__btn btn--circle"
              @click="onClickEdit(template.id)">
              <span class="template__btn-icon material-icons">
                edit
              </span>
            </button>
            <button
              class="template__btn btn--circle ml-2"
              data-testid="delete-template-button"
              @click="onClickDelete(template.id)">
              <span class="template__btn-icon material-icons">
                delete
              </span>
            </button>
          </div>
        </template-list-item>
      </ul>
      <div class="admin__add text-right">
        <router-link to="/admin/templates/add/">
          <button class="admin__add-btn btn--circle-l btn-l-blue">
            <span class="admin__add-icon material-icons">
              add
            </span>
          </button>
        </router-link>
      </div>
    </div>
  </BasePageContainer>
</template>

<script>
// @ts-check
import { mapState } from 'vuex'
import templateListItem from '@/components/view/TemplateListItem.vue'
import PageHeader from '@/components/parts/PageHeader.vue'
import CategoryCheckboxList from '@/components/view/CategoryCheckboxList.vue'

export default {
  components: {
    PageHeader,
    templateListItem,
    CategoryCheckboxList
  },
  data() {
    return {
      /** @type {
       *  { 
       *    "id": number, 
       *    "color": string, 
       *    "title": string, 
       *    "detail": string, 
       *    "sortOrder": number,
       *    "category": object
       *  }[] 
       * } */
      templates: [],
    }
  },
  computed: {
    ...mapState('events', ['selectedCategories', 'pinnedCategories']),
    _templates() {
      const filteredTemplates = this.templates.filter(template => {
        // カテゴリー：なしは常に表示
        if (!template.category) {
          return true
        }
        // 表示選択されたカテゴリーは表示
        if (this.selectedCategories.includes(template.category.id)) {
          return true
        }
        return false
      })

      // ピン留めされているものとそれ以外を分ける
      const [pinnedTemplates, restTemplates] = filteredTemplates.reduce((acc, template) => {
        if (template.category && this.pinnedCategories.includes(template.category.id)) {
          acc[0].push(template)
        } else {
          acc[1].push(template)
        }
        return acc
      }, [[], []])
      return [...pinnedTemplates, ...restTemplates]
    }
  },
  async created() {
    await this.fetchTemplates()
  },
  methods: {
    async fetchTemplates() {
      this.$store.commit('startLoading')
      await this.$axios.get('/events/templates/', { params: { ordering: 'sort_order' } })
        .then((res) => {
          this.templates = res.data.results
        })
        .catch(() => {
          this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
        })
    
      this.$store.commit('finishLoading')
    },
    onClickEdit(id) {
      this.$router.push(`/admin/templates/${id}/edit`)
    },
    async onClickDelete(id) {
      const template = this.templates.find(e=>e.id===id)
      if (!window.confirm(`テンプレート「${template.title}」を削除します。既に作成された予定の内容は変更されません。よろしいですか？`)) return

      this.$store.commit('startLoading')
      await this.$axios.delete(`/events/templates/${template.id}/`)
        .then(()=>{
          this.$store.commit('notify/set', {message: 'テンプレートを削除しました。'})
        })
        .catch(() => {
          this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
          this.$store.commit('finishLoading')
          return
        })
      await this.fetchTemplates()
      this.$store.commit('finishLoading')
    }
  }
}
</script>

<style lang="scss" scoped>
.admin {
  padding-bottom: calc(16px + constant(safe-area-inset-bottom));
  padding-bottom: calc(16px + env(safe-area-inset-bottom));
  &__add {
    right: 16px;
    position: fixed;
    bottom: 0px;
    padding-bottom: calc(80px + constant(safe-area-inset-bottom));
    padding-bottom: calc(80px + env(safe-area-inset-bottom));
  }
  &__add-btn {
    box-shadow: 1px 2px 6px $grey05;
  }
  &__add-icon {
    //ボタン
    font-size: 30px;
    line-height: 54px;
    width: 30px;
  }
}
.admin-head {
  background-color: $l-blue;
  @media screen and (min-width: 992px) {
    right: 0;
    left: 120px;
  }
  &__back {
    height: 22px;
    width: auto;
    color: $white;
    display: inline-block;
    vertical-align: text-bottom;
  }
  &__heading {
    color: $white;
    font-size: $fs-lg;
    font-weight: bold;
  }
}

.admin-templates{
  &__icon{
    vertical-align: middle;
    display: inline-block;
  }
  &__item{
    position: relative;
    background-color: $white;
    border-radius: 8px;
    font-weight: bold;
  }
  
  &__btn{
    position: relative;
    box-shadow: 1px 2px 6px $grey05;
    padding: 2px;
    line-height: 27px;
    @media screen and (min-width:768px) {
      padding: auto;
      line-height: auto;
    }

  }
  &__btn-icon{
    display: inline-block;
    vertical-align: text-bottom;
    font-size: 20px;
  }
}

.template {
  &__actions {
    min-width: 76px;
  }
}

.body-header {
  display: flex;
  justify-content: right;
  position: relative;
  margin: 20px auto;

  ::v-deep .category-list_wrapper {
    right: 0;
  }
}
</style>
